import React, { FC, useEffect, useState } from 'react';
import Styles from './ProductTeaser.module.scss';
import { AssetPathPropConfig } from '../../services/LineTableBasicPropConfig';
import { createCartV2 } from '../../services/LineTableService';
import { countZero, viewport } from '../../utils/utils';
import Cookies from 'js-cookie';
import {
  DEFAULT_MOBILEPOSTPAID_BUNDLE,
  DEFAULT_WIRELINE_BUNDLE,
  DESKTOP,
  FIXNET,
  LARGE_DESKTOP,
  MOBILE,
  TABLET
} from '../../utils/constants';
import RichText from '../richtext';
import ToolTip from '../ToolTip/ToolTip';
import { ProductTeaserPropConfig } from '../../services';
import { ProductTeaserCompSchema, ProductTeaserSlideSchema } from './ProductTeaser';
import { toggleEvent } from '../../Analytics/items';
import {
  ADDTOCART,
  STAGETEASER,
  TOGGLE_OFF_CONFIGURATOR,
  TOGGLE_ON_CONFIGURATOR
} from '../../Analytics/AnalyticsConstants';
import { trackEligibleItem } from '../../models/Analytics/items';
import Dotloader from '../Dotloader/Dotloader';
import LinecheckModal from '../LineCheckV3/LinecheckModal';
import CoverageCheckModal from '../NewLineCheck/CoverageCheckModal';
import { Form } from 'react-bootstrap';

export interface ProductTeaserSlidesSchema {
  content: ProductTeaserCompSchema;
  slides: ProductTeaserSlideSchema;
  index: number;
  offeringData: any;
  lineCheckCallBack?: () => void;
  linecheckSuccessCallBack?: () => void;
  setEnableToggle?: any;
  tableSelectedTab?: string;
  lineCheckOnClear?: () => void;
}

const ProductTeaserSlides: FC<ProductTeaserSlidesSchema> = ({
  content,
  slides,
  index,
  offeringData,
  lineCheckCallBack,
  linecheckSuccessCallBack,
  setEnableToggle,
  tableSelectedTab,
  lineCheckOnClear
}: any) => {
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();
  const cartEndPoint = ProductTeaserPropConfig?.getInstance()?.getCartUrl();
  const [toggle, setToggle] = useState(false);
  const [showLinecheck, setShowLinecheck] = useState(false);
  let address: any = Cookies.get('chAddressJson');
  const viewPort = viewport();
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const enableToggle = slides.selectedTabId === tableSelectedTab;

  //UseEffect to enable the toggle
  useEffect(() => {
    setToggle(enableToggle);
  }, [enableToggle]);

  let bundle = localStorage.getItem('lineCheckResponse');
  let eligibleBundle = bundle && JSON.parse(bundle);
  let code = toggle ? slides?.tvProductId : slides?.productId;
  let isAvailable = address && eligibleBundle?.eligibleBundle?.includes(code);

  //once linecheck success set linecheck pop up false and proceed to checkout section
  const linecheckSuccess = () => {
    linecheckSuccessCallBack();
  };

  const linecheckSuccessAndCart = () => {
    setShowLinecheck(false);
    callCart(slides);
    linecheckSuccessCallBack();
  };
  const callCart = (product: any) => {
    if (product?.productType === FIXNET) {
      bundle = localStorage.getItem('lineCheckResponse');
      address = Cookies.get('chAddressJson');
      eligibleBundle = bundle && JSON.parse(bundle);
      const linecheckId: any = Cookies.get('one-commerce-linecheckcorrelationid');
      code = toggle ? product?.tvProductId : product?.productId;
      isAvailable = address && eligibleBundle?.eligibleBundle?.includes(code);
      if (!isAvailable || !eligibleBundle || !address || !linecheckId) {
        lineCheckCallBack();
      }
      if (isAvailable) {
        //To track add to cart
        Object.keys(offeringData)?.length !== 0 &&
          trackEligibleItem(ADDTOCART, [offeringData[product?.productId]], '', STAGETEASER);
        setShowLoader(true);
        //Create cart call not triggered if offer api fails
        Object.keys(offeringData)?.length !== 0 &&
          createCartV2(
            [offeringData[code]],
            '',
            product?.promoId ? product?.promoId : DEFAULT_WIRELINE_BUNDLE,
            cartEndPoint,
            product?.productType
          )
            .then((res) => {
              Cookies.remove('one-commerce-cartId', { path: '/' });
              // saving newly created cartid in the cookies.
              Cookies.set('one-commerce-cartId', res?.id, { path: '/' });
              Cookies.set('cartProduct', code, { path: '/' });
              Cookies.remove('landline');
              window.location.href = product?.summaryURL?.cached_url;
            })
            .catch((err) => {
              // eslint-disable-next-line no-console
              console.log(err);
              setShowLoader(false);
            })
            .finally(() => {
              setShowLoader(false);
            });
      }
    } else if (product?.productType === MOBILE) {
      //To track add to cart
      setShowLoader(true);
      Object.keys(offeringData)?.length !== 0 &&
        trackEligibleItem(ADDTOCART, [offeringData[product?.productId]], '', STAGETEASER);
      //Create cart
      Object.keys(offeringData)?.length !== 0 &&
        createCartV2(
          [offeringData[product?.productId]],
          '',
          product?.promoId ? product?.promoId : DEFAULT_MOBILEPOSTPAID_BUNDLE,
          cartEndPoint,
          product?.productType
        )
          .then((res) => {
            Cookies.remove('one-commerce-cartId', { path: '/' });
            // saving newly created cartid in the cookies.
            Cookies.set('one-commerce-cartId', res?.id, { path: '/' });
            Cookies.set('cartProduct', product?.productId, { path: '/' });
            window.location.href = product?.summaryURL?.cached_url;
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
            setShowLoader(false);
          })
          .finally(() => {
            setShowLoader(false);
          });
    }
  };

  const priceConatiner = () => {
    let productPrice: number;
    let tvPrice: number;
    const bundle = localStorage.getItem('lineCheckResponse');
    const eligibleBundle = bundle && JSON.parse(bundle);
    const code = toggle ? slides?.tvProductId : slides?.productId;
    const notAvailable = bundle && !eligibleBundle?.eligibleBundle?.includes(code) ? true : false;

    if (offeringData[slides?.productId]?.derivedPrice) {
      productPrice = offeringData[slides?.productId]?.derivedPrice?.[0]?.value;
    } else {
      productPrice = offeringData[slides?.productId]?.prices?.[0]?.value;
    }

    if (offeringData[slides?.tvProductId]?.derivedPrice) {
      tvPrice = offeringData[slides?.tvProductId]?.derivedPrice?.[0]?.value;
    } else {
      tvPrice = offeringData[slides?.tvProductId]?.prices?.[0]?.value;
    }
    return (
      <div
        className={`${fullWidthImage ? Styles.priceContainer : Styles.priceContainerNew}`}
        style={{
          marginLeft: slides?.containerAlignment === 'left' && viewPort !== MOBILE ? '40px' : '',
          marginRight: slides?.containerAlignment === 'right' && viewPort !== MOBILE ? '40px' : ''
        }}
      >
        {notAvailable && slides?.productType === FIXNET && (
          <div className={Styles.serviceUnavail}>
            <img src={`${assetPath}/icons/not-available.svg`} alt='' width={24} height={24} />
            {content?.serviceabilityError}
          </div>
        )}
        {offeringData[slides?.productId]?.prices?.[0]?.value > 0 && (
          <span
            className={`${Styles.priceWrapper} ${
              slides?.containerAlignment === 'left' &&
              slides?.textAlignment !== 'right' &&
              viewPort !== MOBILE
                ? Styles.leftWrapper
                : ''
            }`}
          >
            <div
              className={`${
                slides?.containerAlignment !== 'center' &&
                slides?.textAlignment !== 'center' &&
                viewPort !== MOBILE
                  ? Styles.sliderNew
                  : Styles.slider
              } ${toggle && slides?.productType === FIXNET && Styles.clicked}`}
            >
              {productPrice && (
                <div className={Styles.line}>
                  {slides?.priceTxt && (
                    <div className={Styles.pricetxt}>
                      <RichText content={slides?.priceTxt} />
                    </div>
                  )}
                  {countZero(productPrice)}
                  <p className={Styles.priceDuration}>{slides?.conDuration}</p>
                </div>
              )}
              {tvPrice && (
                <div className={Styles.line}>
                  {slides?.priceTxt && <div className={Styles.pricetxt}>{slides?.priceTxt}</div>}
                  {countZero(tvPrice)}
                  <p className={Styles.priceDuration}>{slides?.conDuration}</p>
                </div>
              )}
            </div>
            <button
              onClick={() => {
                content?.enableLinecheckOverlay && !isAvailable
                  ? setShowLinecheck(true)
                  : callCart(slides);
              }}
              className={`${
                slides?.containerAlignment === 'center' ||
                slides?.textAlignment === 'center' ||
                viewPort === MOBILE
                  ? Styles.callCart
                  : Styles.callCartNew
              }`}
            >
              {isAvailable ? slides?.buttonLbl : slides?.checkAvailability}
              <img
                className={Styles.arrowIcon}
                src={content?.btnIcon?.filename}
                alt='submit'
                width={24}
                height={24}
              />
            </button>
          </span>
        )}
        <div
          className={
            slides?.containerAlignment === 'left' &&
            slides?.textAlignment === 'left' &&
            viewPort !== MOBILE
              ? Styles.priceDescCenter
              : slides?.containerAlignment === 'left' &&
                slides?.textAlignment === 'center' &&
                viewPort !== MOBILE
              ? Styles.priceLeftCenter
              : slides?.containerAlignment === 'center' ||
                slides?.textAlignment === 'center' ||
                viewPort === MOBILE
              ? Styles.priceDesc
              : Styles.priceDescNew
          }
        >
          {slides?.priceDesc}
        </div>
      </div>
    );
  };
  const fullWidthImage = slides?.isFullWidthImage;
  const containerLeft = true
    ? viewPort === LARGE_DESKTOP && slides?.containerAlignment === 'left'
    : false;
  const containerRight = true
    ? viewPort === LARGE_DESKTOP && slides?.containerAlignment === 'right'
    : false;
  const containerCenter = true
    ? viewPort === LARGE_DESKTOP && slides?.containerAlignment === 'center'
    : false;
  const textLeft = true ? viewPort === LARGE_DESKTOP && slides?.textAlignment === 'left' : false;
  const textRight = true ? viewPort === LARGE_DESKTOP && slides?.textAlignment === 'right' : false;
  return (
    <div className=''>
      <div className={Styles.carouselItem} key={index}>
        {showLoader && <Dotloader keyParams='loading' />}
        {/* teaser with full width image for all alignment */}
        {viewPort === LARGE_DESKTOP && slides?.desktopBGImage?.filename && fullWidthImage && (
          <img
            src={slides?.desktopBGImage?.filename + '/m/'}
            alt='desktop teaser'
            width='100%'
            height='550px'
            className={Styles.teaserImage}
          />
        )}{' '}
        {/* teaser with transparent image for left and right container alignment */}
        {viewPort === LARGE_DESKTOP &&
          slides?.desktopBGImage?.filename &&
          !fullWidthImage &&
          slides?.containerAlignment !== 'center' && (
            <img
              src={slides?.desktopBGImage?.filename + '/m/'}
              alt='desktop teaser'
              width='50%'
              height='550px'
              className={`${
                slides?.containerAlignment === 'left'
                  ? Styles['teaserImageLeft']
                  : Styles['teaserImageRight']
              }`}
            />
          )}
        {(viewPort === TABLET || viewPort === DESKTOP) && slides?.tabBGImage?.filename && (
          <img
            src={slides?.tabBGImage?.filename}
            alt='tablet Teaser'
            width='100%'
            height='550px'
            className={Styles.teaserImage}
          />
        )}
        {viewPort === MOBILE && slides?.mobileBGImage?.filename && (
          <img
            src={slides?.mobileBGImage?.filename}
            alt='mobile Teaser'
            width='100%'
            height='500px'
            className={Styles.teaserImage}
          />
        )}
        {/* content alignment wrt the image */}
        <div
          className={`${
            viewPort === TABLET || viewPort === DESKTOP
              ? Styles.contentWrapper
              : containerLeft
              ? Styles.contentWrapperLeft
              : containerRight
              ? Styles.contentWrapperRight
              : Styles.contentMobWrapper
          }`}
        >
          {/* Alignment of content and images wrt each scenario */}
          <div
            className={`${
              containerLeft || containerRight
                ? Styles.productDetailsWrapperNew
                : containerCenter && fullWidthImage
                ? Styles.productDetailsWrapper
                : containerCenter && !fullWidthImage
                ? Styles.productDetailsWrapperTransparent
                : ''
            }`}
          >
            {/* Text Alignment */}
            <div
              className={`${Styles.titleSection} ${
                content?.productTeaserSlides?.length > 1 && Styles.extraSpace
              }
            ${textLeft ? 'text-start' : textRight ? 'text-end' : 'text-center'}
            `}
            >
              {slides?.heading && (
                <>
                  {!toggle && <div className={`${Styles.heading}`}>{slides?.heading}</div>}
                  {slides?.tvSubHeading && toggle && (
                    <div
                      className={`${Styles.heading} ${
                        toggle ? Styles.fadeInText : Styles.fadeOutText
                      }`}
                    >
                      {slides?.tvSubHeading}
                    </div>
                  )}
                </>
              )}
              {slides?.subHeading && <div className={Styles.paragraph}>{slides?.subHeading}</div>}
              {slides?.description && (
                <div className={Styles.description}>
                  <RichText content={slides?.description} />
                </div>
              )}
            </div>
            {/* Transparent Image with center Alignment  */}
            <div>
              {containerCenter && slides?.desktopBGImage?.filename && !fullWidthImage && (
                <img
                  src={slides?.desktopBGImage?.filename + '/m/'}
                  alt='transparent Image'
                  width='196px'
                  height='196px'
                />
              )}
            </div>
            <div className={Styles.featureSection}>
              {slides?.details?.length > 0 && (
                <div className={Styles.featureList}>
                  {(slides?.details || [])?.map((data: any, key: number) => (
                    <React.Fragment key={key}>
                      {key > 0 && viewPort !== MOBILE && <div className={Styles.horizontalLine} />}
                      <div className={Styles.features}>
                        {data?.icon?.filename && (
                          <img
                            className={Styles.featureIcon}
                            src={
                              viewPort === MOBILE ? data?.mobIcon?.filename : data?.icon?.filename
                            }
                            alt='icon'
                            width={24}
                            height={24}
                          />
                        )}
                        {data?.text && (
                          <>
                            <div className='me-auto'>
                              <RichText
                                content={data?.text}
                                linkAsTooltip={data?.linkTxt !== '' ? true : false}
                                toolTipText={data?.linkTxt}
                              />
                            </div>
                            {data?.tooltipTxt && (
                              <ToolTip content={data?.tooltipTxt} tooltipClass={Styles.toolTip} />
                            )}
                          </>
                        )}
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              )}
              {viewPort === MOBILE &&
                slides?.productType === FIXNET &&
                Object.keys(offeringData)?.length > 0 && (
                  <div className={Styles.horizontalLineDark} />
                )}
              {slides?.productType === FIXNET &&
                slides?.tvDetails?.length > 0 &&
                slides?.tvProductId !== '' && (
                  <div className={Styles.addOnSection}>
                    <img
                      src={
                        viewPort === MOBILE
                          ? slides?.tvDetails?.[0]?.mobIcon?.filename
                          : slides?.tvDetails?.[0]?.icon?.filename
                      }
                      className={Styles.addOnSectionIcon}
                      alt='tv'
                      width={24}
                      height={24}
                    />
                    <RichText content={slides?.tvDetails?.[0]?.text} />
                    <span className={`d-flex align-items-center ${Styles.toggleSection}`}>
                      <span className={Styles.toggle}>{slides?.tvPrice}</span>
                      <Form>
                        <Form.Check
                          type='switch'
                          readOnly={true}
                          onClick={() => {
                            setToggle(!toggle);
                            setEnableToggle(!toggle);
                            //To track the toggle event
                            toggleEvent(
                              !toggle ? TOGGLE_ON_CONFIGURATOR : TOGGLE_OFF_CONFIGURATOR,
                              slides?.heading,
                              (slides?.tvDetails?.[0]?.text?.content?.[0]?.content?.[0]?.text).replace(
                                /[^a-zA-Z ]/g,
                                ''
                              )
                            );
                          }}
                          checked={toggle}
                        />
                      </Form>
                      {slides?.tvDetails?.[0]?.tooltipTxt && (
                        <ToolTip
                          content={slides?.tvDetails?.[0]?.tooltipTxt}
                          tooltipClass={Styles.toolTip}
                        />
                      )}
                    </span>
                  </div>
                )}
              {viewPort === MOBILE && Object.keys(offeringData)?.length > 0 && (
                <>
                  <div className={Styles.horizontalLineDark} />
                  {priceConatiner()}
                </>
              )}
            </div>
          </div>
          {viewPort !== MOBILE && Object.keys(offeringData)?.length > 0 && <>{priceConatiner()}</>}

          {/* lincheck modal */}
          {showLinecheck &&
          content?.enableLinecheckOverlay &&
          slides?.productType === FIXNET &&
          content?.linecheckData?.length > 0 &&
          content?.linecheckData?.[0]?.reference?.default_full_slug ===
            'global/new-linecheck-test' ? (
            <LinecheckModal
              content={content?.linecheckData?.[0]}
              onSuccess={linecheckSuccessAndCart}
              showModal={showLinecheck}
              setShowModal={setShowLinecheck}
              productName={slides?.heading}
            />
          ) : showLinecheck &&
            content?.enableLinecheckOverlay &&
            slides?.productType === FIXNET &&
            content?.linecheckData?.length > 0 &&
            content?.linecheckData?.[0]?.reference?.default_full_slug ===
              'global/coverage-check' ? (
            <CoverageCheckModal
              content={content?.linecheckData?.[0].reference.content.body[0]}
              overlayIsOpen={true}
              externalHandleModal={setShowLinecheck}
              productName={slides?.heading}
              showModal={showLinecheck}
              setShowModal={setShowLinecheck}
              onSuccess={linecheckSuccess}
              onCreateCart={linecheckSuccessAndCart}
              lineCheckOnClear={lineCheckOnClear}
              productId={toggle ? slides?.tvProductId : slides?.productId}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ProductTeaserSlides;
